import { render, staticRenderFns } from "./reminderUpdatePopup.vue?vue&type=template&id=26fbae0c&scoped=true&"
import script from "./reminderUpdatePopup.vue?vue&type=script&lang=js&"
export * from "./reminderUpdatePopup.vue?vue&type=script&lang=js&"
import style0 from "./reminderUpdatePopup.vue?vue&type=style&index=0&id=26fbae0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26fbae0c",
  null
  
)

export default component.exports